import { Button } from '@/components/atoms';
import ClampedText from '@/components/atoms/ClampedText';
import ImgWithFallback from '@/components/atoms/ImgWithFallback';
import eventImage from '@/images/event.webp';
import { HELPERS, defaultSizes } from '@/utils';
import { useTranslation } from 'react-i18next';

export const EventCatalogHero = () => {
  const { t } = useTranslation();
  const { SIZES, VARIANTS } = Button;

  const description = `Event menghadirkan kelas untuk belajar bisnis secara real time (live zoom) bersama para praktisi yang inspiratif. 
    Kelas yang tersedia terdiri atas kelas pendek berdurasi 2 hari (disebut live class) & kelas intensive berdurasi 2 pekan (disebut bootcamp).`;

  const scrollToCatalog = () => {
    const catalogSection = document.getElementById('catalog');
    HELPERS.sendEventGA('click_explore_event_button', { page_source: 'Event Catalog' });

    if (catalogSection) {
      const offset = 48;
      const catalogPosition = catalogSection.getBoundingClientRect().top;
      const currentScrollPosition = window.scrollY || window.pageYOffset;
      const offsetPosition = catalogPosition + currentScrollPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="relative max-h-128 bg-gradient-to-br from-white to-primary-100 pt-8 lg:pt-2">
      <div className="container flex flex-wrap lg:space-x-24 items-start lg:bg-transparent lg:py-16 ">
        <div className="relative w-full lg:w-4/12 z-10 lg:bg-transparent">
          <div className="absolute inset-x-0 h-1/2 bg-gray-50 lg:hidden" aria-hidden="true" />
          <div className="max-w-md mx-auto sm:max-w-3xl lg:max-w-none lg:p-0">
            <div className="aspect-w-10 aspect-h-6 sm:aspect-w-2 sm:aspect-h-1 lg:aspect-w-1">
              <ImgWithFallback
                className="object-cover object-center rounded-3xl shadow h-full w-full"
                src={eventImage}
                sizes={defaultSizes}
                alt="Ilustrasi Event"
              />
            </div>
          </div>
        </div>
        <div className="relative w-full lg:flex-1 lg:rounded-3xl lg:items-center">
          <div className="relative max-w-md mx-auto py-12 sm:max-w-3xl sm:py-16 sm:px-6 lg:max-w-none lg:p-0 space-y-6">
            <h1
              className="text-4xl font-extrabold bg-gradient-to-bl from-primary-800 from-[26.17%] to-secondary-400 to-[119.1%] bg-clip-text text-transparent"
              id="title"
              style={{ WebkitTextFillColor: 'transparent' }}
            >
              Event & Workshop
            </h1>
            <div>
              <ClampedText
                content={description}
                initialClampLines={4}
                classNames={{
                  content: 'text-md text-gray-800 mt-0',
                  button: 'text-secondary font-bold text-md mt-0',
                }}
              />
            </div>

            <div className="lg:flex items-center space-x-4 hidden">
              <Button
                onClick={scrollToCatalog}
                className="text-base font-semibold w-full lg:w-auto"
                size={SIZES.MEDIUM}
                variant={VARIANTS.SECONDARY}
              >
                Jelajahi Event
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
